<template>
  <div class="benefit-visitor-wrap">
    <div class="title">{{ item.name }}</div>
    <div class="desc">{{ item.desc }}</div>
    <div class="product-list">
      <van-image
        class="product-item"
        v-for="item in item.productInfo"
        :key="item.id"
        :src="item.icon_img_url"
        @click="handleProductClick(item)"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { useRouter } from "@/components/use/base";

export default defineComponent({
  props: ["item"],
  setup() {
    const router = useRouter();

    const handleProductClick = (item) => {
      router.push(`benefitDetail?benefit_type=${item.benefit_type}`);
    };

    return { handleProductClick };
  },
});
</script>

<style lang="less" scoped>
.benefit-visitor-wrap {
  margin-top: 32px;
  padding: 0 12px;

  .title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 22px;
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    margin-top: 7px;
  }

  .product-list {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .product-item {
      width: 171px;
      height: 65px;
      margin-bottom: 8px;

      &:nth-child(3),
      &:nth-child(4) {
        margin-bottom: 0;
      }
    }
  }
}
</style>
